import Button from '@/shared/Buttons/Button'
import PdfIcon from '@/assets/icons/icon-pdf-file.svg?react'
import FolderIcon from '@/assets/icons/folder-open.svg?react'
import { cmsNavigationGroups } from '../cms.constants'
import { CmsSectionKey } from '../cms.types'
import css from '../cms.module.css'

interface IProps {
  activeSection: CmsSectionKey
  userLogin: string
  onChange: (section: CmsSectionKey) => void
  onLogout: () => void
}

const CmsSidebar = ({ activeSection, userLogin, onChange, onLogout }: IProps) => {
  return (
    <aside className={css.sidebar}>
      <div className={css.sidebarHeader}>
        <div className={css.brand}>
          <div className={css.brandMark}>VK</div>
          <div style={{ minWidth: 0 }}>
            <p className="text-nm-bold line-clamp">Landing CMS</p>
          </div>
        </div>
      </div>

      <div className={css.sidebarContent}>
        <div className={css.navGroup}>
          <p className="text-caption text-description">Файлы</p>
          <button className={css.navButton} data-active={activeSection === 'assets'} onClick={() => onChange('assets')}>
            <span className="inline-flex-gap gap8 center">
              <FolderIcon style={{ width: 16, height: 16 }} />
              <span className="text-nm">Медиафайлы</span>
            </span>
          </button>
          <button
            className={css.navButton}
            data-active={activeSection === 'eventProgram'}
            onClick={() => onChange('eventProgram')}
          >
            <span className="inline-flex-gap gap8 center">
              <PdfIcon style={{ width: 16, height: 16 }} />
              <span className="text-nm">Программа</span>
            </span>
          </button>
        </div>

        <div className={css.navGroup}>
          <p className="text-caption text-description">Аудитория</p>
          <button
            className={css.navButton}
            data-active={activeSection === 'emailSubscriptions'}
            onClick={() => onChange('emailSubscriptions')}
          >
            <span className="text-nm line-clamp">Email подписчики</span>
          </button>
        </div>

        {cmsNavigationGroups.map((group) => (
          <div className={css.navGroup} key={group.title}>
            <p className="text-caption text-description">{group.title}</p>
            {group.items.map((resource) => (
              <button
                className={css.navButton}
                data-active={activeSection === resource.key}
                onClick={() => onChange(resource.key)}
                key={resource.key}
              >
                <span className="text-nm line-clamp">{resource.title}</span>
              </button>
            ))}
          </div>
        ))}
      </div>

      <div style={{ marginTop: 'auto', padding: 16, borderTop: '1px solid var(--border-secondary-color)' }}>
        <Button size="default" type="default" text="Выйти" fullWidth onClick={onLogout} />
      </div>
    </aside>
  )
}

export default CmsSidebar
